export default "__VITE_ASSET__4Nc79S21__"